/* src/app/components/data-request/data-request.component.scss */
.main-bgColor {
  height: 100%;
  overflow-y: auto;
}
mat-icon {
  vertical-align: middle;
}
/*# sourceMappingURL=data-request.component.css.map */
